import AttachmentList from "./AttachmentList";
import { statusChangeText } from "./supportTicketStatus";

const when = (value) => (value ? new Date(value).toLocaleString() : "");

/** A reply as a bubble on its author's side; a status change as a line across the thread. */
const TicketEntry = ({ entry, viewerSide }) => {
  if (entry.kind === "STATUS_CHANGE") {
    return (
      <li className="my-3 text-center">
        <p className="m-0 inline-block rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-600">
          {statusChangeText(entry)} · {when(entry.createdAt)}
        </p>
        {entry.body ? (
          <p className="m-0 mt-1 text-xs italic text-slate-500 whitespace-pre-wrap">
            &ldquo;{entry.body}&rdquo;
          </p>
        ) : null}
      </li>
    );
  }

  const mine = entry.side === viewerSide;
  return (
    <li className={`my-2 flex ${mine ? "justify-end" : "justify-start"}`}>
      <div
        className={`max-w-[85%] rounded-2xl border px-3 py-2 ${
          mine ? "border-teal-200 bg-teal-50" : "border-slate-200 bg-white"
        }`}
      >
        <p className="m-0 text-xs font-semibold text-slate-700">
          {entry.authorName || (entry.side === "OFFICE" ? "The office" : "Partner")}
          <span className="ml-2 font-normal text-slate-400">{when(entry.createdAt)}</span>
        </p>
        {entry.body ? (
          <p className="m-0 mt-1 text-sm text-slate-800 whitespace-pre-wrap break-words">
            {entry.body}
          </p>
        ) : null}
        <AttachmentList attachments={entry.attachments} />
      </div>
    </li>
  );
};

export default TicketEntry;
